export const faqCompanies = [
  {
    section: "Getting Started",
    items: [
      { q: "Can we start small?", a: "Yes! You can begin with one contractor and expand anytime." },
      { q: "How fast is onboarding?", a: "Typically within 5–10 business days once documents are verified." },
      { q: "Can we hire part-time contractors?", a: "Yes, Mapeach supports both part-time and full-time models." },
      { q: "Does Mapeach help with recruitment?", a: "Yes, we can source, screen, and onboard the right talent for your needs." },
      { q: "Can we bring our own candidate?", a: "Absolutely. Mapeach can compliantly onboard your pre-selected contractor." },
      { q: "Do you work with startups and enterprises?", a: "Yes. Mapeach scales to fit early-stage startups and large enterprises alike." },
      { q: "Is there a minimum contract period?", a: "No minimum term — short or long projects are fine." }
    ]
  },
  {
    section: "Contracts & Legal",
    items: [
      { q: "Can we add our own clauses?", a: "Yes. NDAs, IP rights, confidentiality, and project terms can be customized." },
      { q: "Do we own the contractor’s work product?", a: "Yes. All intellectual property created belongs to your company as stated in the contract." },
      { q: "Are NDAs included?", a: "Yes, every contractor signs a strict NDA before accessing client materials." },
      { q: "How are contracts signed?", a: "All contracts are securely executed with digital signatures." },
      { q: "How do terminations work?", a: "Mapeach handles compliant offboarding per labor regulations." },
      { q: "Can we rehire later?", a: "Yes, re-onboarding a past contractor is quick and simple." },
      { q: "Are non-compete clauses possible?", a: "Yes, if relevant to the engagement." },
    ]
  },
  {
    section: "Payments & Taxes",
    items: [
      { q: "How do we pay contractors?", a: "You pay Mapeach in your preferred currency; we pay contractors locally in INR." },
      { q: "Do we handle Indian taxes?", a: "No. Mapeach takes care of all Indian statutory taxes and filings." },
      { q: "Can we get invoices in USD/EUR/GBP?", a: "Yes. We support most major currencies." },
      { q: "What payment methods can we use?", a: "Wire transfer, SWIFT, ACH, or credit card." },
      { q: "Any hidden fees?", a: "None. All pricing is upfront and transparent." },
      { q: "When do we pay invoices?", a: "Typically within 15–30 days, depending on agreed terms." },
      { q: "Can bonuses be paid?", a: "Yes. We can process bonuses or commissions." },
      { q: "How are FX rates handled?", a: "We use transparent, real-time conversion rates." }
    ]
  },
  {
    section: "Work & Operations",
    items: [
      { q: "Are all roles remote?", a: "Yes, primarily remote, with optional hybrid setups." },
      { q: "Can we provide equipment?", a: "Yes, Mapeach can help coordinate secure device logistics." },
      { q: "Do contractors match our time zone?", a: "Generally yes, as agreed in the contract." },
      { q: "Can we interview candidates?", a: "Absolutely. You select your preferred hire." },
      { q: "How do we handle performance issues?", a: "Mapeach mediates feedback and manages improvements or replacements." },
      { q: "Can contractors work with other clients?", a: "Usually exclusive, unless otherwise approved." },
      { q: "Is background verification done?", a: "Yes, every contractor undergoes ID and reference checks." },
      { q: "Do they follow our holidays?", a: "Yes, unless otherwise agreed." },
    ]
  },
  {
    section: "Data & Compliance",
    items: [
      { q: "Is data security enforced?", a: "Yes, all contractors follow strict confidentiality and IT policies." },
      { q: "Can we require VPN or secure devices?", a: "Yes, those policies can be enforced." },
    ]
  }
];


